import React from "react";
import { CONTENT, C, block, anchorHref, Wordmark, Button, ThemeSwitch } from "./shared";

export function Header() {
  const onInstructions = !!CONTENT.instructions_path && window.location.pathname.startsWith(CONTENT.instructions_path);
  return (
    <header style={{
      position: "sticky", top: 0, zIndex: 20, display: "flex", alignItems: "center", gap: 26,
      padding: "15px clamp(20px, 5vw, 56px)", background: "var(--header-bg)",
      backdropFilter: "blur(12px)", WebkitBackdropFilter: "blur(12px)", borderBottom: "1px solid var(--border-soft)",
    }}>
      <a href={anchorHref("#top")} style={{ textDecoration: "none", display: "flex", alignItems: "center", gap: 10 }}>
        <Wordmark />
      </a>
      {/* menu items come from blocks flagged "in menu" in the admin */}
      <nav className="fr-nav" style={{ display: "flex", gap: 24, flex: 1, fontSize: 14, fontWeight: 500 }}>
        {(CONTENT.menu || []).map((item) => (
          <a key={item.anchor} href={anchorHref(item.anchor)} style={{ color: "var(--text-muted)", textDecoration: "none", whiteSpace: "nowrap" }}>{item.label}</a>
        ))}
        {/* present only while at least one instruction is published (admin) */}
        {CONTENT.instructions_path && (
          <a href={CONTENT.instructions_path} aria-current={onInstructions ? "page" : undefined}
             style={{ color: onInstructions ? "var(--text-display)" : "var(--text-muted)", textDecoration: "none", whiteSpace: "nowrap" }}>{C.instructions}</a>
        )}
      </nav>
      <ThemeSwitch />
      <Button size="sm" onClick={() => { window.location.href = block("cta")?.cta_url || "#cta"; }}>{C.signIn}</Button>
    </header>
  );
}
